export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_INVALID_DATE_OF_BIRTH = 'InvalidDateOfBirth'
export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_MISMATCH_DATE = 'MismatchDate'
export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_INVALID_REFERENCE_NUMBER = 'InvalidReferenceNumber'
export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_EXPIRED_REFERENCE_NUMBER = 'ExpiredReferenceNumber'
export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_UNKNOWN = 'MissingDataOrUnknown'

export const TAX_OFFICE_AUTHENTICATION_CLAVE_PIN_REQUEST_ERROR_TYPE_NOT_REGISTERED_FOR_CLAVE_PIN =
    'NotRegisteredForClavePin'

export const TAX_OFFICE_AUTHENTICATION_ERROR_TYPE_MAX_ATTEMPTS_REACHED = 'MaxAttemptsReached'

export const TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_ERROR_TYPE_CADASTRAL_REFERENCE_MISSING =
    'TaxOfficeAddressConfirmationCadastralReferenceMissing'
export const TAX_OFFICE_AUTHENTICATION_ADDRESS_COULD_NOT_BE_SYNCHRONIZED = 'TaxOfficeAddressCouldNotBeSynchronized'

export const getIsAddressConfirmableViaTaxOfficeByError = (error) => {
    return (
        error?.errorType === TAX_OFFICE_AUTHENTICATION_ADDRESS_CONFIRMATION_ERROR_TYPE_CADASTRAL_REFERENCE_MISSING ||
        error?.errorType === TAX_OFFICE_AUTHENTICATION_ADDRESS_COULD_NOT_BE_SYNCHRONIZED
    )
}

export const getIsTaxOfficeNIF = (uniqueTaxpayerReference) =>
    !!uniqueTaxpayerReference && !!uniqueTaxpayerReference.match(/^[KLM]/)

export const getIsNIF = (uniqueTaxpayerReference) => uniqueTaxpayerReference && !!uniqueTaxpayerReference.match(/^[\d]/)

export const getIsNIE = (uniqueTaxpayerReference) =>
    uniqueTaxpayerReference && !!uniqueTaxpayerReference.match(/^[a-jn-zA-JN-Z]/)

export const obscureSensitiveData = (
    data,
    { replaceLettersWith: letterReplacement = '$1', replaceNumbersWith: numberReplacement = '$1' } = {}
) => data?.replace(/([A-Za-z])/g, letterReplacement).replace(/([0-9])/g, numberReplacement) || ''

export const formatSupportNumber = (supportNumber) => {
    if (typeof supportNumber !== 'string') return supportNumber

    let formattedSupportNumber = supportNumber.trim()

    if (isValidSupportNumber(formattedSupportNumber)) return formattedSupportNumber

    const startsByLetter = supportNumber.match(/^[A-Za-z]/)
    if (!startsByLetter) formattedSupportNumber = `C${supportNumber}`

    const [letter, ...numberSequence] = formattedSupportNumber
    const zeroPaddedNumberSequence = numberSequence.join('').padStart(8, '0')

    return `${letter}${zeroPaddedNumberSequence}`

    function isValidSupportNumber() {
        if (!supportNumber) return false
        if (!supportNumber.match(/^[A-Za-z]{1}[\d]{8}$/)) return false

        return true
    }
}

const validUniqueTaxpayerReferenceRegex = /([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])/
export const getIsValidUniqueTaxpayerReference = (uniqueTaxpayerReference) => {
    if (!uniqueTaxpayerReference) return false
    if (uniqueTaxpayerReference.length !== 9) return false

    return validUniqueTaxpayerReferenceRegex.test(String(uniqueTaxpayerReference))
}

// @TODO: Create a company domain and move there instead?
const validCompanyUniqueTaxpayerReferenceRegex = /[A-Za-z]{1}[0-9]{8}/
export const getIsValidCompanyUniqueTaxpayerReference = (uniqueTaxpayerReference) => {
    if (!uniqueTaxpayerReference) return false
    if (uniqueTaxpayerReference.length !== 9) return false

    return validCompanyUniqueTaxpayerReferenceRegex.test(String(uniqueTaxpayerReference))
}

export const formatTaxOfficeAddress = (taxOfficeAddress) =>
    [
        ...(taxOfficeAddress.streetType && taxOfficeAddress.streetName
            ? [`${taxOfficeAddress.streetType}/${taxOfficeAddress.streetName}`]
            : []),
        ...(!taxOfficeAddress.streetType && taxOfficeAddress.streetName ? [taxOfficeAddress.streetName] : []),
        ...(taxOfficeAddress.number ? [`nº ${parseInt(taxOfficeAddress.number, 10)}`] : []),
        ...(taxOfficeAddress.flat ? [taxOfficeAddress.flat] : []),
        ...(taxOfficeAddress.block ? [`bloque ${taxOfficeAddress.block}`] : []),
        ...(taxOfficeAddress.stairs ? [`escalera ${taxOfficeAddress.stairs}`] : []),
        ...(taxOfficeAddress.floor ? [`piso ${taxOfficeAddress.floor}`] : []),
        ...(taxOfficeAddress.door ? [`puerta ${taxOfficeAddress.door}`] : []),
    ].join(', ')

export const formatTaxOfficeCity = (taxOfficeAddress) =>
    [
        ...(taxOfficeAddress.zipCode ? [taxOfficeAddress.zipCode] : []),
        ...(taxOfficeAddress.town ? [taxOfficeAddress.town] : []),
        ...(taxOfficeAddress.city ? [taxOfficeAddress.city] : []),
        ...(taxOfficeAddress.province ? [taxOfficeAddress.province] : []),
    ].join(', ')
